import React, { useState } from "react";
import { DndContext, closestCenter, DragOverlay } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import { Box, Typography } from "@mui/material";
import DraggableWord from "./DraggableWord";
import DropZone from "./DropZone";

type Word = {
  id: string;
  text: string;
};

const initialWords: Word[] = [
  { id: "1", text: "The" },
  { id: "2", text: "most" },
  { id: "3", text: "recognised" },
  { id: "4", text: "are" },
  { id: "5", text: "the Group of 8." },
];

const SentenceBuilder: React.FC = () => {
  const [sentence, setSentence] = useState<Word[]>([]);
  const [words, setWords] = useState<Word[]>(initialWords);
  const [activeWord, setActiveWord] = useState<Word | null>(null);

  const handleDragStart = (event: any) => {
    const { active } = event;
    const word =
      words.find((word) => "draggable" + word.id === active.id) ||
      sentence.find((word) => word.id === active.id);
    console.log(word, "active word", active);
    setActiveWord(word || null);
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;

    setActiveWord(null);

    if (!over) {
      return;
    }

    if (over.id === "words-drop-zone") {
      const activeWord = words.find(
        (word) => "draggable" + word.id === active.id
      );
      if (activeWord) {
        setSentence((prevSentence) => [...prevSentence, activeWord]);
        setWords((prevWords) =>
          prevWords.filter((word) => "draggable" + word.id !== active.id)
        );
      }
    } else {
      if (active.id !== over.id) {
        setWords((items) => {
          const oldIndex = items.findIndex(
            (item) => "draggable" + item.id === active.id
          );
          const newIndex = items.findIndex(
            (item) => "draggable" + item.id === over.id
          );
          return arrayMove(items, oldIndex, newIndex);
        });
      }
    }
  };

  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <Box sx={{ padding: "24px" }}>
        <Typography variant="h5" gutterBottom>
          Arrange the sentence in the correct order
        </Typography>
        <DropZone
          sentence={sentence}
          setSentence={setSentence}
          correctOrder={initialWords.map((w) => w.text)}
          activeId={activeWord?.id || null} // Pass the active word's ID
        />
        <Box sx={{ marginTop: "150px", display: "flex", flexWrap: "wrap" }}>
          {words.map((word) => (
            <DraggableWord key={word.id} word={word} />
          ))}
        </Box>
      </Box>

      {/* <DragOverlay>
        {activeWord ? <DraggableWord word={activeWord} /> : null}
      </DragOverlay> */}
    </DndContext>
  );
};

export default SentenceBuilder;
